import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { DelegationsControllerService } from '@osos/shared/api';
import {
  DelegationPresenterModel,
  ManagedHttpContext,
} from '@osos/shared/types';
import { of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { DelegationFactoryService } from '../../factories/index';
import { UserPreferencesState } from '../index';
import { DelegationActions } from './delegation.actions';

export interface DelegationStateModel {
  availableDelegations: DelegationPresenterModel[];
  activeDelegation: DelegationPresenterModel;
  loaded: boolean;
}

@State<DelegationStateModel>({
  name: 'delegations',
  defaults: {
    availableDelegations: [],
    activeDelegation: null,
    loaded: false,
  },
})
@Injectable()
export class DelegationState {
  constructor(
    private delegationsControllerService: DelegationsControllerService,
    private delegationFactoryService: DelegationFactoryService,
    private store: Store,
  ) {}

  @Selector()
  static activeDelegationUserId(state: DelegationStateModel): string {
    return state.activeDelegation?.delegator?.dataEntry;
  }

  @Selector()
  static activeDelegationDetails(
    state: DelegationStateModel,
  ): DelegationPresenterModel {
    return state.activeDelegation;
  }

  @Selector()
  static availableDelegations(
    state: DelegationStateModel,
  ): DelegationStateModel {
    return state;
  }

  @Action(DelegationActions.LoadActiveDelegationDetails)
  loadActiveDelegationDetails({
    setState,
  }: StateContext<DelegationStateModel>) {
    const activeDelegationId = this.store.selectSnapshot(
      UserPreferencesState.activeDelegationId,
    );

    if (!activeDelegationId) {
      return of();
    }

    return this.delegationsControllerService
      .getActiveDelegations({
        context: new ManagedHttpContext({
          bypassPublicMiddleware: true,
          bypassDelegationMiddleware: true,
        }),
      })
      .pipe(
        tap((delegations) => {
          const models = delegations.map((d) =>
            this.delegationFactoryService.createPresenterModel(d),
          );
          setState(
            patch<DelegationStateModel>({
              availableDelegations: models,
              activeDelegation: models.find((d) => d.id == activeDelegationId),
              loaded: true,
            }),
          );
        }),
      );
    // return this.delegationsControllerService
    //   .getDelegation({
    //     id: activeDelegationId,
    //     context: new ManagedHttpContext({
    //       bypassPublicMiddleware: true,
    //       bypassDelegationMiddleware: true,
    //     }),
    //   })
    //   .pipe(
    //     tap((d) => {
    //       if (!d) {
    //         this.store.dispatch(
    //           new UserPreferencesActions.SetActiveDelegation(null)
    //         );
    //         return;
    //       }
    //       setState(
    //         patch<DelegationStateModel>({
    //           activeDelegation:
    //             this.delegationFactoryService.createPresenterModel(d),
    //         })
    //       );
    //     })
    //   );
  }

  @Action(DelegationActions.FetchAvailableDelegations)
  loadActiveDelegations({ setState }: StateContext<DelegationStateModel>) {
    return this.delegationsControllerService
      .getActiveDelegations({
        context: new ManagedHttpContext({
          bypassPublicMiddleware: true,
          bypassDelegationMiddleware: true,
        }),
      })
      .pipe(
        tap((delegations) => {
          setState(
            patch<DelegationStateModel>({
              availableDelegations: delegations.map((d) =>
                this.delegationFactoryService.createPresenterModel(d),
              ),
              loaded: true,
            }),
          );
        }),
      );
  }
}
